// Display all tab component such as agent llm etc

function TabComponent({ tabs, activeTab, onTabClick }) {
    return (
        <nav
            className="agent-tabs"
            role="tablist"
            aria-label="Agent configuration tabs"
        >
            {tabs.map((tab) => (
                <div
                    key={tab}
                    role="tab"
                    tabIndex={0}
                    aria-selected={activeTab === tab}
                    className={
                        activeTab === tab ? 'agent-tab-item selected' : 'agent-tab-item'
                    }
                    onClick={() => onTabClick(tab)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            onTabClick(tab);
                        }
                    }}
                >
                    {tab}
                </div>
            ))}
        </nav>
    );
}

export default TabComponent;
